import { getLicenseVisualStatus } from 'shared-ui/lib/utils/license-status'

export type VehicleLicenseRow = {
  licenseExpireDate?: string | null
  licenseStatus?: string | null
}

/**
 * true jos jollakin ajoneuvolla lisenssi vaatii huomiota (ei voimassa, punainen tai oranssi).
 * Lista rajattu 200 ajoneuvoon GraphQL-kyselyssä.
 */
export const vehiclesNeedLicenseAttention = (vehicles: VehicleLicenseRow[]): boolean =>
  vehicles.some((v) => {
    const { level } = getLicenseVisualStatus({
      licenseExpireDate: v.licenseExpireDate,
      licenseStatus: v.licenseStatus,
    })
    return level === 'NO_ACTIVE' || level === 'ORANGE' || level === 'RED'
  })
